/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  QueryFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  GetWalletsResponse,
  UserWalletDTO,
  GetWalletSummaryResponse,
  GetExchangableAssetResponse,
  UtxWalletGetExchangableAssetsParams,
  GetWalletBalanceResponse,
  GetWalletsByAssetResponse,
  GetAssetUnderCustodyResponse
} from './schema'



/**
 * Retrieved users wallets/accounts
 */
export const utxWalletGetWallets = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetWalletsResponse>> => {
    return axios.get(
      `/wallets`,options
    );
  }


export const getUtxWalletGetWalletsQueryKey = () => [`/wallets`];

    
export type UtxWalletGetWalletsQueryResult = NonNullable<Awaited<ReturnType<typeof utxWalletGetWallets>>>
export type UtxWalletGetWalletsQueryError = AxiosError<unknown>

export const useUtxWalletGetWallets = <TData = Awaited<ReturnType<typeof utxWalletGetWallets>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxWalletGetWallets>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxWalletGetWalletsQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxWalletGetWallets>>> = ({ signal }) => utxWalletGetWallets({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxWalletGetWallets>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxWalletGetUserWallet = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UserWalletDTO[]>> => {
    return axios.get(
      `/wallets/list`,options
    );
  }


export const getUtxWalletGetUserWalletQueryKey = () => [`/wallets/list`];

    
export type UtxWalletGetUserWalletQueryResult = NonNullable<Awaited<ReturnType<typeof utxWalletGetUserWallet>>>
export type UtxWalletGetUserWalletQueryError = AxiosError<unknown>

export const useUtxWalletGetUserWallet = <TData = Awaited<ReturnType<typeof utxWalletGetUserWallet>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxWalletGetUserWallet>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxWalletGetUserWalletQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxWalletGetUserWallet>>> = ({ signal }) => utxWalletGetUserWallet({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxWalletGetUserWallet>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxWalletGetWalletSummary = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetWalletSummaryResponse[]>> => {
    return axios.get(
      `/wallets/summary`,options
    );
  }


export const getUtxWalletGetWalletSummaryQueryKey = () => [`/wallets/summary`];

    
export type UtxWalletGetWalletSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof utxWalletGetWalletSummary>>>
export type UtxWalletGetWalletSummaryQueryError = AxiosError<unknown>

export const useUtxWalletGetWalletSummary = <TData = Awaited<ReturnType<typeof utxWalletGetWalletSummary>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxWalletGetWalletSummary>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxWalletGetWalletSummaryQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxWalletGetWalletSummary>>> = ({ signal }) => utxWalletGetWalletSummary({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxWalletGetWalletSummary>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * Get user exchangable wallet assets
 */
export const utxWalletGetExchangableAssets = (
    params?: UtxWalletGetExchangableAssetsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetExchangableAssetResponse[]>> => {
    return axios.get(
      `/wallets/exchangable-assets`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxWalletGetExchangableAssetsQueryKey = (params?: UtxWalletGetExchangableAssetsParams,) => [`/wallets/exchangable-assets`, ...(params ? [params]: [])];

    
export type UtxWalletGetExchangableAssetsQueryResult = NonNullable<Awaited<ReturnType<typeof utxWalletGetExchangableAssets>>>
export type UtxWalletGetExchangableAssetsQueryError = AxiosError<unknown>

export const useUtxWalletGetExchangableAssets = <TData = Awaited<ReturnType<typeof utxWalletGetExchangableAssets>>, TError = AxiosError<unknown>>(
 params?: UtxWalletGetExchangableAssetsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxWalletGetExchangableAssets>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxWalletGetExchangableAssetsQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxWalletGetExchangableAssets>>> = ({ signal }) => utxWalletGetExchangableAssets(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxWalletGetExchangableAssets>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * Get one wallet by the uuid or the public address ( if any ).
 */
export const utxWalletFindWallet = (
    meta: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetWalletBalanceResponse>> => {
    return axios.get(
      `/wallets/${meta}`,options
    );
  }


export const getUtxWalletFindWalletQueryKey = (meta: string,) => [`/wallets/${meta}`];

    
export type UtxWalletFindWalletQueryResult = NonNullable<Awaited<ReturnType<typeof utxWalletFindWallet>>>
export type UtxWalletFindWalletQueryError = AxiosError<unknown>

export const useUtxWalletFindWallet = <TData = Awaited<ReturnType<typeof utxWalletFindWallet>>, TError = AxiosError<unknown>>(
 meta: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxWalletFindWallet>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxWalletFindWalletQueryKey(meta);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxWalletFindWallet>>> = ({ signal }) => utxWalletFindWallet(meta, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxWalletFindWallet>>, TError, TData>(queryKey, queryFn, {enabled: !!(meta), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * Get user wallets by asset
 */
export const utxWalletGetWalletByAsset = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetWalletsByAssetResponse[]>> => {
    return axios.get(
      `/wallets-by-asset`,options
    );
  }


export const getUtxWalletGetWalletByAssetQueryKey = () => [`/wallets-by-asset`];

    
export type UtxWalletGetWalletByAssetQueryResult = NonNullable<Awaited<ReturnType<typeof utxWalletGetWalletByAsset>>>
export type UtxWalletGetWalletByAssetQueryError = AxiosError<unknown>

export const useUtxWalletGetWalletByAsset = <TData = Awaited<ReturnType<typeof utxWalletGetWalletByAsset>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxWalletGetWalletByAsset>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxWalletGetWalletByAssetQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxWalletGetWalletByAsset>>> = ({ signal }) => utxWalletGetWalletByAsset({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxWalletGetWalletByAsset>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * UI support api for asset under custody
 */
export const utxWalletGetAssetUnderCustody = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetAssetUnderCustodyResponse[]>> => {
    return axios.get(
      `/users/asset-under-custody`,options
    );
  }


export const getUtxWalletGetAssetUnderCustodyQueryKey = () => [`/users/asset-under-custody`];

    
export type UtxWalletGetAssetUnderCustodyQueryResult = NonNullable<Awaited<ReturnType<typeof utxWalletGetAssetUnderCustody>>>
export type UtxWalletGetAssetUnderCustodyQueryError = AxiosError<unknown>

export const useUtxWalletGetAssetUnderCustody = <TData = Awaited<ReturnType<typeof utxWalletGetAssetUnderCustody>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxWalletGetAssetUnderCustody>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxWalletGetAssetUnderCustodyQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxWalletGetAssetUnderCustody>>> = ({ signal }) => utxWalletGetAssetUnderCustody({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxWalletGetAssetUnderCustody>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

